import React, { Component } from 'react';
import { IoIosWarning } from "react-icons/io";
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
  constructor(props){
    super(props);
    this.state = {
      error_found: false,
      errorMessage: null
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ 
      error_found: true,
      errorMessage: errorInfo
    });
  }

  isBrowserSupported = () => {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    let isOpera = typeof window.opr !== 'undefined';

    // If Internet Explorer or Opera
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || isOpera) {
      return false;
    } 
    return true;
  }

  render() {
    const { error_found, errorMessage, IE_browser_issue } = this.state;

    const unsupportedContent = (<div><p className="not-supported-browser">Om deze website te kunnen bezoeken dient u gebruik te maken van &eacute;&eacute;n van de volgende webbrowsers: Chrome, FireFox, Safari and Edge</p></div>)

    if (error_found && this.isBrowserSupported()) {
      return (
        <div className="success-message text-center" style={{ height: "100vh" }}>
          <div className="icon">
            <IoIosWarning size={48}/>
          </div>
          <h3>Er is een fout opgetreden !</h3>
          <p>{errorMessage}</p>
        </div>
      );
    }

    return this.isBrowserSupported() ? this.props.children : unsupportedContent; 
  }
}

